import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';
import { useInfoModal } from './hooks/useInfoModal';
import { getModalContentComponentByType } from './utils/getModalContentByType';

export const ModalContainer: React.FC = () => {
  const { isModalOpen, handleCloseModal, modalContent, modelType } = useInfoModal();

  const ContentComponent = React.useMemo(
    () =>
      getModalContentComponentByType({
        type: modelType,
        content: modalContent,
      }),
    [modelType, modalContent],
  );

  return (
    <ModalWindow open={isModalOpen} content={ContentComponent} onClose={handleCloseModal} fixed width={600} size="XS" />
  );
};

ModalContainer.displayName = 'ModalContainer';
